'use strict';

angular.module('riskEventModule', [
    'governanceProcessModule',
    'boxTemplateModule'
]);